import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableService } from '@docpath/linces-angular-components';
import { DPCardsInfoModule, DpChartModule, DpFilterCardModule, DpHeaderModule, DpPaginationModule, DpSearchModule, DpTableModule } from '@docpath/webcomponents';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { SinclairCardsModule } from 'src/app/shared/components/sinclair-cards/sinclair-cards.module';

import { StatisticsChartComponent } from './components/chart/statistics-chart.component';
import { StatisticsHeaderComponent } from './components/header/statistics-header.component';
import { StatisticsTableComponent } from './components/table/statistics-table.component';
import { LogComponent } from './log/log.component';
import { StatisticsComponent } from './statistics.component';

@NgModule({
  declarations: [
    StatisticsComponent,
    StatisticsChartComponent,
    LogComponent,
    StatisticsTableComponent,
    StatisticsHeaderComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SinclairCardsModule,
    DpChartModule,
    DpFilterCardModule,
    DpHeaderModule,
    FontAwesomeModule,
    DpTableModule,
    DpSearchModule,
    DpHeaderModule,
    DpPaginationModule,
    DPCardsInfoModule
  ],
  providers: [
    TableService
  ]
})
export class StatisticsModule { }